<template>
    <router-link
        to="/app/minha-caixa"
        class="caixa-bell-btn"
        :title="titulo">
        <i class="pi pi-inbox text-xl"></i>
        <Badge
            v-if="count > 0"
            :value="count > 99 ? '99+' : count"
            severity="warn"
            class="caixa-badge" />
    </router-link>
</template>

<script>
import Badge from 'primevue/badge';
import MinhaCaixa from '@/service/minhaCaixa.js';
import AuthUser from '@/utils/AuthUser.js';

export default {
    components: { Badge },
    data() {
        return { count: 0, pollTimer: null, projetoId: null };
    },
    computed: {
        titulo() {
            if (this.count === 0) return 'Caixa vazia';
            return `${this.count} sites aguardando acao`;
        },
    },
    async mounted() {
        this.projetoId = await AuthUser.projetoDefaultId();
        if (!this.projetoId) return;
        this.load();
        this.pollTimer = setInterval(() => this.load(), 60000);
    },
    beforeUnmount() {
        if (this.pollTimer) clearInterval(this.pollTimer);
    },
    methods: {
        load() {
            if (!this.projetoId) return;
            MinhaCaixa.count(this.projetoId)
                .then(r => { this.count = r.data.count || 0; })
                .catch(() => {});
        },
    },
};
</script>

<style scoped>
.caixa-bell-btn {
    background: transparent;
    border: 1px solid rgba(255,255,255,0.75);
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 6px;
    position: relative;
    transition: background 0.15s ease;
    display: inline-flex;
    align-items: center;
}
.caixa-bell-btn:hover {
    background: rgba(255,255,255,0.15);
}
.caixa-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    font-size: 10px !important;
    min-width: 18px !important;
    height: 18px !important;
    line-height: 18px !important;
    padding: 0 5px !important;
}
.router-link-active.caixa-bell-btn {
    background: rgba(255,255,255,0.25);
}
</style>
